var browser = require('browser');
var IRCFormatter = require('ircformatter');

var not = window.Notification;
// We need to store these so they don't get garbage collected and lose their event handlers
var notStore = {};
var notIds = 0;

var macgap = window.macgap;

// https://notifications.spec.whatwg.org/
function notifier (session) {
    this.session = session;
}

notifier.supported = !!(not || macgap);
notifier.shouldRequest = function () {
    if (macgap) {
        // Notifications always allowed without permissions
        return false;
    } else if (not) {
        // Request if no decision has yet been made
        return not.permission === 'default';
    } else {
        // Notifications not supported
        return false;
    }
};
notifier.allowed = function () {
    if (macgap) {
        // Notifications always allowed without permissions
        return true;
    } else if (not) {
        // Check if explicitly granted
        return not.permission === 'granted';
    } else {
        // Notifications not supported
        return false;
    }
};
notifier.requestPermission = function (callback) {
    if (notifier.allowed() || !notifier.supported) {
        return;
    }
    try {
        not.requestPermission(function (permission) {
            callback(permission);
        });
    } catch (exc) {
        debug.warn('Notification.requestPermission', exc);
    }
};

notifier.prototype = {
    notify: function (options) {
        var tag = 'irccloudNotification:' + options.tag;
        var title = options.title;
        var body = options.body;
        var click = options.click || $.noop;
        var close = options.close || $.noop;
        var show = options.show || $.noop;
        var iconSize = '72';
        if (browser.isHighDensity()) {
            iconSize = '144';
        }
        var icon = this.session.getOrigin() + '/static/favicon/favicon-' + iconSize + 'x' + iconSize + '.png';
        if (macgap) {
            // Native notifications
            macgap.notice.notify({
                title: title,
                content: body,
                id: tag,
                sound: false,
                silent: true
            });
        } else if (not) {
            if (!notifier.allowed()) {
                if (notifier.shouldRequest()) {
                    notifier.requestPermission(_.bind(function (permission) {
                        this.session.trigger('notificationPermissionRequested', permission);
                        if (permission === 'granted') {
                            this.notify(options);
                        }
                    }, this));
                }
                return;
            }
            // WebKit/W3C Notifications
            var uid = ++notIds;
            
            var notification;
            if (not) {
                if (this.session.isDesktop() && browser.isLinux()) {
                    // linux desktop spec allows markup in body
                    // https://developer.gnome.org/notification-spec/#markup
                    // Escape it so people can't leak IPs with <img> or spoof links
                    // This is probably better fixed by electron checking for
                    // 'body-markup' in the notify-osd server caps/info
                    body = IRCFormatter.escapeHtmlLinuxNotification(body);
                }
                var notOptions = {
                    body: body,
                    tag: tag,
                    silent: true
                };
                if (options.image) {
                    notOptions.icon = options.image;
                } else if (!this.session.isDesktop()) {
                    notOptions.icon = icon;
                }
                notification = new not(title, notOptions);
                // For debug tracking
                notification.irccloud_uid = uid;
                // Chrome doesn't recognise these when set in options
                // Safari doesn't call them at all seemingly
                notification.onclick = _.bind(function (event) {
                    this.session.trigger('notificationClick');
                    click(notification);
                }, this);
                notification.onclose = function (event) {
                    delete notStore[uid];
                    close(notification);
                };
                notification.onshow = function (event) {
                    notStore[uid] = notification;
                    show(notification);
                };
                // Call manually to track notification for Safari
                notification.onshow();
                setTimeout(function () {
                    notification.close();
                    // Call this manually for Safari
                    notification.onclose();
                }, 5000);
            }
            
            return;
        
        }
        return;
    }
};

module.exports = notifier;



//////////////////
// WEBPACK FOOTER
// ./app/src/irccloudnotifier.js
// module id = 9cM4
// module chunks = 1